module.exports = __webpack_public_path__ + "static/media/MarkerFelt-Wide.fcee5f1a.svg";